import React, { useEffect, useState } from "react";
import Link from "helpers/link";

const Card = ({ bannerText, authorImage, Image, author, date, title, description, link, Button }) => {
  const [expandDescription, setExpandDescription] = useState(false);
  const [shortenDescription, setShortenDescription] = useState("");

  useEffect(() => {
    setShortenDescription(
      description.length > 120
        ? description.substring(0, 120) + "..."
        : description
    );
  }, [description]);

  return (
    <div className="h-full flex flex-col relative overflow-hidden">
      {bannerText && (
          <p className="absolute top-0 left-0 bg-[#31CA31] text-white px-8 md:px-4 py-4 md:py-2 text-2xl md:text-sm rounded-tl rounded-br font-montserrat font-bold">
            {bannerText}
          </p>
      )}
      {Image && (
        <div className="w-full h-[240px] rounded overflow-hidden">
          <Link to={link}>
            {Image}
          </Link>
        </div>
      )} 
      <div className="flex flex-col px-7 pt-4 pb-7 sm:px-4 border border-gray-300 rounded-b-lg rounded-t-lg flex-1 bg-gray-200">
        <div className="flex justify-between w-full second-div items-center">
          <div className="flex items-center">
            <div className="w-[50px] h-[50px] rounded-full mr-[12px]">
              <img
                src={authorImage}
                alt={author}
                className="w-full h-full rounded-full object-cover"
              />
            </div>
            <p className="text-gray-700 font-montserrat font-medium text-base sm:text-sm">{author}</p>
          </div>
          <div className="text-xs font-montserrat font-medium text-[#BCBCBC]">{date}</div>
        </div>
        <div>
          <Link to={link}>
            <h3 className="text-xl sm:text-base font-bold font-montserrat mt-4 text-gray-700">{title}</h3>
          </Link>
          <p className="text-base mt-4 font-montserrat text-gray-700 font-light">
            {expandDescription ? description : shortenDescription}
          </p>
          <p
            className={`text-base cursor-pointer font-montserrat text-gray-700 font-light ${description.length > 120 ? "visible" : "invisible"}`}
            onClick={() => setExpandDescription(!expandDescription)}
          >
            {expandDescription ? "Show Less" : "[...]"}
          </p>
        </div>
        {Button && (
          <div className="mt-auto">
            {Button}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
